import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ReturnIcon from '@material-ui/icons/ArrowBack';
import ClosingIcon from '@material-ui/icons/Lock';
import ImportIcon from '@material-ui/icons/Unarchive';
import ExportIcon from '@material-ui/icons/Archive';
import RUCarsListTable from './RUCarsListTable';
import ConfirmationDialog from '../../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import ExcelAPI from '../../../../API/UsedRentalsExcelAPI';
import { handleServerError } from '../../../../Utils/Helper';
import { UR_GROUP, UR_PHASE } from '../../../../Utils/Constants';
import UsedRentalsCarsListAPI from '../../../../API/UsedRentalsCarsListAPI';


const styles = theme => ({
  textBlack: {
    color: '#000000'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  appBar: {
    backgroundColor: '#F6F6F6'
  },
  flex: {
    flex: 1
  },
  carModelPaper: {
    padding: '0px 32px',
    backgroundColor: theme.palette.primary.light
  },
  toolbarHeight: {
    minHeight: '52px'
  }
});


export class RUCarsListContent extends Component {
  excelAPI;
  l4ListAPI;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      openDialog: false,
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      openError: false,
      alertMessage: '',
      urlDownload: '',
      fileName: '',
      openDialogForced: false
    };
    this.excelAPI = new ExcelAPI();
    this.l4ListAPI = new UsedRentalsCarsListAPI();
  }

  componentWillReceiveProps() {
    this.setState({ urlDownload: '' });
  };

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
    document.getElementById('file').value = ''
  };

  handleCloseL4Edition = () => {
    this.props.handleCloseL4Edition();
  };

  handleGoBack = () => {
    this.props.handleGoBack();
  };

  handleCloseDialogForced = () => {
    this.setState({ openDialogForced: false });
  };

  handleChangeSelect = name => value => {
    this.setState({ [name]: value });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleClickClosing = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende FECHAR o Lote?',
      confirmationMessage: 'As viaturas do Lote da marca ' + this.props.negotiationLot.Brand + ' e modelo ' + this.props.negotiationLot.Model + ' ficarão disponíveis apenas para visualização em histórico.',
      confirmationFunction: this.handleSubmitCarClosing,
      cancelFunction: this.handleCloseDialog
    });
  };

  handleSubmitCarClosing = () => {
    this.setState({ loading: true })
    this.l4ListAPI.finishFirmPurchasesLot(this.props.negotiationLot.L1ID).then(() => {
      this.setState({
        loading: false,
        success: true
      });
      this.handleCloseDialog();
      this.handleCloseL4Edition();
      this.handleGoBack();
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog()
    })
  };

  handleClickExport = () => {
    this.excelAPI.getRUExcelCarsList(this.props.negotiationLot.L1ID).then(response => {
      this.setState({
        urlDownload: response.request.responseURL
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleClickImportExcel = () => {
    document.querySelector('#file').click();
  };

  handleChange = name => event => {
    const sFileName = event.target.value;
    this.setState({
      fileName: sFileName,
      [name]: '',
      openDialog: true,
      success: false,
      confirmationQuestion: 'Tem a certeza que pretende submeter o ficheiro ' + sFileName + ' ?',
      confirmationMessage: 'Os valores serão registados ou, em caso de alteração de valores já existentes, sobrepostos a esses mesmos.',
      confirmationFunction: () => this.handleClickSubmitFile(false),
      cancelFunction: this.handleCloseDialog
    });
  };

  handleConfirmForceSave = () => {
    this.setState({
      loading: false,
      openDialog: false,
      openDialogForced: true,
      confirmationFunction: () => this.handleClickSubmitFile(true),
      cancelFunction: this.handleCloseDialogForced
    });
  };

  handleClickSubmitFile = (ForceSave) => {
    const formData = new FormData();
    this.setState({ loading: true });
    let excelfile = document.querySelector('#file');
    formData.append('excel_carros', excelfile.files[0]);
    this.excelAPI.postRUExcelCarsList(formData, this.props.negotiationLot.L1ID, ForceSave).then(() => {
      this.setState({
        loading: false,
        success: true,
        openSuccess: true,
        openDialog: false,
        alertMessage: 'Ficheiro submetido com sucesso!',
        fileName: ''
      });
      setTimeout(() => {
        this.setState({
          openSuccess: false,
          autoHideDuration: 3000
        })
      }, 3000);
      this.handleCloseDialogForced();
      this.handleCloseDialog();
    }).catch((error) => {
      let errorMessage = handleServerError(error);
      if (errorMessage.indexOf('sejam alertados') > -1) {
        this.setState({
          confirmationQuestion: 'Tem a certeza que pretende IMPORTAR O EXCEL?',
          confirmationMessage: 'As viaturas da marca ' + this.props.negotiationLot.Brand +
            ' e modelo ' + this.props.negotiationLot.Model +
            ' possuem reservas associadas à totalidade de viaturas disponíveis, a importação do Excel terá impacto sobre as reservas. '
            + handleServerError(error)
        })
        this.handleConfirmForceSave();
      }
      else {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        });
        this.handleCloseDialog();
        this.handleCloseDialogForced();
      }
    });
    document.getElementById('file').value = ''
  };


  render() {
    const { classes } = this.props;

    return (
      <Dialog
        fullScreen
        open={this.props.openL4Edition}
        onClose={this.handleCloseL4Edition.bind(this)}
      >
        <iframe title='openExcel' style={{ display: 'none' }} src={this.state.urlDownload}></iframe>
        <div>
          <input style={{ display: 'none' }} type='file' id='file' name='file' accept='.xls, .xlsx' onChange={this.handleChange('path')} />
        </div>

        <AppBar className={classes.appBar}>

          <Toolbar className={classes.toolbarHeight} >
            <Tooltip title='Retroceder' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleCloseL4Edition.bind(this)}>
                <ReturnIcon />
              </Button>
            </Tooltip>
            <Typography variant='title' className={classNames(classes.flex, classes.textBlack)}>
              VIATURAS RENTING USADOS
            </Typography>
            <Tooltip title='Receber Excel' placement='bottom' >
              <Button type='file' variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickImportExcel}
                disabled={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0}>
                <ImportIcon />
              </Button>
            </Tooltip>
            <Tooltip title='Enviar Excel' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickExport}
                disabled={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0}>
                <ExportIcon />
              </Button>
            </Tooltip>
            <Tooltip title='Fechar Lote' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleClickClosing() }}
                disabled={this.props.estadoLotId !== UR_PHASE || this.props.user.UserRoleType.indexOf(UR_GROUP) < 0}>
                <ClosingIcon />
              </Button>
            </Tooltip>
          </Toolbar>

          <Paper className={classes.carModelPaper}>
            <Grid container spacing={8}>
              <Grid item xs={12} sm={4}>
                <TextField
                  id='brand'
                  label='MARCA'
                  margin='dense'
                  fullWidth
                  InputProps={{ readOnly: true }}
                  value={this.props.negotiationLot.Brand}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField
                  id='model'
                  label='MODELO'
                  margin='dense'
                  fullWidth
                  InputProps={{ readOnly: true }}
                  value={this.props.negotiationLot.Model}
                />
              </Grid>
            </Grid>
          </Paper>

        </AppBar>

        <RUCarsListTable estadoLotId={this.props.estadoLotId} reloadRUManagementLotsTableList={this.props.reloadRUManagementLotsTableList.bind(this)} handleGoBack={this.handleGoBack.bind(this)} handleCloseL4Edition={this.handleCloseL4Edition.bind(this)} excelImport={this.state.alertMessage} />

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleCloseDialog.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <Dialog
          open={this.state.openDialogForced}
          onClose={this.handleCloseDialogForced}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialogForced}
            handleClose={this.handleCloseDialogForced.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <SnackbarAlert autoHideDuration={this.state.autoHideDuration} openSuccess={this.state.openSuccess} openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Dialog>
    )
  }
}

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(RUCarsListContent));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsManagement/UsedRentalsCarsList/RUCarsListContent.js